module.exports = __webpack_public_path__ + "static/spanish-bread-954971744303aab629cade0d05acf7ad.jpg";